const clearArr = [
    6564920,6587694,6627581,6569544,6569541,6569540,6569539,6558540,6568783,6569008,6569036,
    6569106,/**6562065 20221201 产品梳理群后来要求隐藏,**/6562066,6589040,6589044,6599740,6598285,6590072,6590074,6590051,6590056,
    6604269,6599927,6604214,6592195/*,6587732*/,6587763,6587774,6587843,6588151,6588147,6588143,
    6588139,6588137,6588098,6588099,6588101,6588075,6588080,6588081,6588059,6588027,6588028,
    6588029,6588030,6588031,6587978,6587979,6587980,6587981,6587982,6587920,6587894,6587897,
    6587899,6587901,6587887,6587888,6628295,6628296,6628304,6628305,6628323,6628324,6628325,
    6628326,6628327,6628334,6628335,6628336,6628318,6628319,6628320,6628321,6628338,6628339,
    6628340,6628344,6628290,6628291,6628292,6628298,6628299,6628300,6628301,6628302,6628329,
    6628331,6628332,6628342,6567661,6567662,6567665,6567670,6567673,6569158,6569159,6569160,
    6569161,6564180,6564181,6564185,6564186,6564192,6564195,6564200,6564201,6564210,6564211,
    6564214,/* 12月14日需求恢复标签 6573792,6573797,6574574,6574576,6574588,6574606,6574643,*/6564620,6564624,6564627,
    6564630,6564631,6632050,6632051,6632052,6564652,6564654,6564655,6564661,6564667,6564668,
    6564671,6564674,6564718,6564773,6564782,6564789,6564796,6564806,6564822,6564877,6565037,
    6565038,6565078,6565079,6565083,6565092,6565204,6565221,6565222,6565227,6565228,6565229,
    6565230,6565243,6565255,6565256,6565270,6565301,6565302,6565322,6577060,6575469,6593952,
    6565770,6563870,6589159,6563880,6589160,6578425,6585001,6585003,
    6563768,6561490,6592673,
    6575469,//城乡市容管理
6577060,//录音制作
6565322,//补充保险
6565302,//健身休闲活动
6565301,//体育场地设施管理
6565270,//体育场馆建筑
6565256,//非金融机构支付服务
6565255,//控股公司服务
6565243,//证券期货监管服务
6565230,//保险监管服务
6565229,//保险资产管理
6565228,//保险中介服务
6565227,//商业养老金
6565222,//银行监管服务
6565221,//银行理财服务
6565092,//搬家运输
6565079,//其他城市公共交通运输
6565078,//公共自行车服务
6565038,//煤气生产和供应业
6565037,//液化石油气生产和供应业
6564920,//苇田
6564877,//增量房（非住房买卖）
6564822,//摩托车
6564806,//鞭炮、焰火
6564796,//其他转让所得
6564789,//其他财产租赁所得
6564782,//稿酬所得
6564773,//构筑物-增量房
6564718,//不动产融资租赁
6564674,//其他采矿业
6564671,//黑色金属矿产品
6564668,//盐
6564667,//洗煤
6564661,//家具制造业
6564655,//其他电气机械及器材制造业
6564654,//电线电缆
6564652,//家用电器
6632052,//自行车
6632051,//摩托车
6564631,//水泥制品
6564630,//水泥
6564627,//汽车轮胎
6564624,//护肤护发品
6564620,//化学化工产品
6601737,//商品和服务税收分类和编码
6611492,//货物
6611499,//农、林、牧、渔业类产品
6611501,//农业产品
6613051,//谷物
6613054,//稻谷
6617342,//货物和劳务名称说明
6613056,//小麦
6617343,//货物和劳务名称说明
6613057,//玉米
6617344,//货物和劳务名称说明
6613058,//谷子
6617345,//货物和劳务名称说明
6613059,//高粱
6617347,//货物和劳务名称说明
6613060,//大麦
6617348,//货物和劳务名称说明
6613061,//燕麦
6613062,//黑麦
6613063,//荞麦
6613065,//其他谷物
6613066,//薯类
6613067,//马铃薯
6613068,//木薯
6613070,//甘薯
6613071,//其他薯类
6613074,//油料作物
6613075,//花生
6613076,//油菜籽
6613077,//芝麻
6613078,//其他油料
6613079,//干豆类
6613080,//大豆
6613082,//绿豆
6613084,//其他杂豆
6613085,//棉花
6613087,//生麻
6613088,//糖料
6613089,//甘蔗
6613090,//甜菜
6613091,//其他糖料
6613092,//未加工烟草
6613093,//未去梗烤烟叶
6613104,//其他未加工烟草
6613109,//饲料作物
6613110,//饲料牧草
6613112,//其他饲料作物
6613114,//水生植物类
6613115,//农作物副产品
6613249,//作物茎、秆、根
6613251,//其他农作物副产品
6613116,//蔬菜及食用菌
6613228,//萝卜等根菜类蔬菜
6613229,//山药等薯芋类蔬菜
6613231,//葱蒜类蔬菜
6613232,//白菜类蔬菜
6613233,//芥菜类蔬菜
6613234,//甘蓝类蔬菜
6613235,//芹菜等叶菜类蔬菜
6613236,//瓜类蔬菜
6613237,//番茄等茄果类蔬菜
6613241,//菜豆等豆类蔬菜
6613243,//莲藕等水生蔬菜
6613244,//竹笋等多年生及杂类蔬菜
6613246,//香菇等食用菌
6613247,//绿豆芽等芽苗菜
6613248,//其他蔬菜
6613117,//花卉
6613220,//盆栽花
6613221,//鲜切花及花蕾
6613223,//切叶
6613224,//切枝
6613226,//干燥花
6613118,//盆景及园艺产品
6613215,//园艺产品
6613217,//盆栽观叶植物
6613218,//草皮
6613219,//草坪
6613216,//其他盆景及园艺产品
6613119,//水果及坚果
6613141,//水果（园林水果）--------------------------------------
6613146,//苹果
6613149,//梨
6613150,//柑橘类水果
6613151,//葡萄
6613152,//香蕉
6613154,//菠萝
6613155,//龙眼
6613156,//荔枝
6613157,//枇杷
6613158,//红毛丹
6613159,//芒果
6613162,//橄榄
6613163,//无花果
6613164,//鳄梨
6613165,//番石榴
6613166,//山竹果
6613167,//杨桃
6613168,//莲雾
6613170,//火龙果
6613171,//西瓜
6613172,//哈密瓜
6613174,//华莱士瓜
6613175,//香瓜
6613176,//伊利沙白瓜
6613177,//木瓜
6613178,//樱桃
6613179,//枣
6613180,//红果
6613181,//柿子
6613183,//桃
6613185,//李子
6613186,//石榴
6613187,//杏
6613188,//杨梅
6613189,//草莓
6613190,//黑莓
6613191,//桑椹
6613193,//沙棘
6613194,//其他未列明水果
6613142,//干制水果
6613143,//食用坚果
6613195,//椰子
6613196,//腰果
6613197,//核桃
6613198,//山核桃
6613200,//栗子
6613202,//松子
6613203,//榛子
6613204,//阿月浑子果（开心果）
6613205,//槟榔
6613207,//白果
6613208,//香榧
6613209,//巴旦杏
6613211,//夏威夷果
6613212,//其他食用坚果
6613120,//茶及饮料原料
6613136,//茶叶
6613137,//饮料原料
6613138,//其他未列明饮料原料
6613121,//香料原料
6613122,//中草药材
6613123,//种子、种苗
6613124,//种用谷物
6613125,//种用薯类
6613126,//种用油料
6613127,//种用豆类
6613128,//种用饲料作物
6613130,//蔬菜籽
6613131,//花草种
6613132,//水果籽
6613133,//其他种子、种苗
6611502,//林业产品
6613255,//育种和育苗
6613256,//木材采伐产品
6613277,//原木
6613278,//小规格木材
6613279,//薪材
6613280,//短条及细枝等
6613281,//其他木材采伐产品
6613258,//竹材采伐产品
6613275,//原竹
6613276,//其他竹材采伐产品
6613260,//林产品
6613266,//天然橡胶
6613267,//天然树脂、树胶
6613268,//栲胶原料
6613269,//非直接食用果类
6613270,//编结用原料
6613271,//染色、鞣革用植物原料
6613272,//野生植物活体
6613273,//野生植物采集产品
6613274,//其他林产品
6611503,//饲养动物、野生动物及其产品
6613283,//活牲畜
6613288,//猪
6613289,//牛
6613290,//马
6613291,//驴
6613292,//骡
6613293,//羊
6613294,//骆驼
6613295,//其他活牲畜
6613284,//活家禽
6613296,//活鸡
6613297,//活鸭
6613298,//活鹅
6613299,//其他活家禽
6613285,//畜禽产品
6613300,//生奶
6613301,//禽蛋
6613312,//鸡蛋
6613313,//鸭蛋
6613314,//鹅蛋
6613315,//鹌鹑蛋
6613316,//其他禽蛋
6613302,//天然蜂蜜及副产品
6613317,//天然蜂蜜
6613318,//蜂蜡
6613319,//鲜蜂王浆
6613320,//其他天然蜂蜜及副产品
6613303,//蚕茧
6613304,//动物毛类
6613305,//生皮
6613306,//生毛皮
6613307,//制刷用兽毛
6613308,//麝香
6613309,//鹿茸
6613310,//燕窝
6613311,//其他畜禽产品
6613286,//野生动物禽类
6613325,//野生动物
6613326,//野生鸟类
6613327,//其他野生动物
6613287,//其他饲养动物
6611504,//海水养殖、捕捞产品
6613324,//海水鱼
6613328,//海水虾
6613329,//海水蟹
6613330,//海水贝类
6613331,//海水藻类
6613332,//海水软体水生动物
6613333,//海水产品种苗
6613334,//其他海水产品
6611505,//淡水养殖产品、捕捞产品
6613335,//淡水鱼
6613336,//淡水虾
6613337,//淡水蟹
6613338,//淡水贝类
6613339,//淡水藻类
6613340,//淡水鲜软体动物
6613341,//淡水产品种苗
6613342,//其他淡水产品
6611506,//矿产品
6613344,//煤炭采选产品
6613350,//原煤
6613351,//洗煤
6613352,//其他煤炭采选产品（低热值燃料）
6613345,//石油和天然气开采产品
6613353,//原油
6613359,//天然原油
6613360,//沥青矿原油
6613354,//天然气
6613355,//液化天然气
6613356,//煤层气
6613357,//天然气水合物
6613358,//油页岩
6613361,//沥青页岩
6613362,//油母页岩
6613363,//焦（重）油砂
6613364,//其他油页岩
6613346,//黑色金属矿石
6613365,//铁矿石
6613366,//锰矿石
6613367,//铬矿石
6613347,//有色金属矿石
6613368,//常用有色金属矿石
6613373,//铜矿石
6613374,//铅锌矿石
6613375,//镍矿石
6613376,//钴矿石
6613377,//锡矿石
6613378,//锑矿石
6613379,//铝土矿石
6613380,//镁矿石
6613381,//汞矿石
6613382,//铋矿石
6613383,//钛矿石
6613384,//钠矿石
6613385,//其他常用有色金属矿石
6613369,//贵金属矿石
6613386,//金矿砂及其精矿石
6613387,//银矿砂及其精矿石
6613388,//其他贵金属矿石
6613370,//稀有稀土金属矿石
6613389,//钨矿石
6613390,//钼矿石
6613391,//稀土矿产品
6613393,//高钇混合稀土氧化物
6613394,//中钇富铕混合稀土氧化物
6613395,//低钇低铕混合稀土氧化物
6613396,//高钇混合碳酸稀土（折氧化物计量计价）
6613397,//中钇富铕混合碳酸稀土（折氧化物计量计价）
6613398,//低钇低铕混合碳酸稀土（折氧化物计量计价）
6613399,//高钇混合草酸稀土（折氧化物计量计价）
6613400,//中钇富铕混合草酸稀土（折氧化物计量计价）
6613401,//低钇低铕混合草酸稀土（折氧化物计量计价）
6613402,//磷钇矿精矿（折氧化物计量计价）
6613403,//独居石精矿（折氧化物计量计价）
6613404,//氟碳铈精矿（折氧化物计量计价）
6613405,//氟碳铈镧矿精矿（折氧化物计量计价）
6613406,//氟碳铈矿-独居石混合精矿（折氧化物计量计价）
6613407,//混合碳酸稀土（折氧化物计量计价）
6613408,//混合氯化稀土（折氧化物计量计价）
6613409,//钐钴废料（折氧化物计量计价）
6613410,//钕铁硼废料（折氧化物计量计价）
6613411,//稀土荧光材料废料（折氧化物计量计价）
6613412,//稀土储氢材料废料（折氧化物计量计价）
6613413,//稀土抛光粉废料（折氧化物计量计价）
6613414,//稀土催化剂废料（折氧化物计量计价）
6613415,//其他稀土废料（折氧化物计量计价）
6613392,//磷钇矿石
6613371,//放射性金属矿石
6613416,//铀矿石
6613417,//钍矿石
6613372,//其他有色金属矿石
6613418,//锂矿石
6613419,//铍矿石
6613420,//铯矿石
6613421,//钽矿石
6613422,//铌矿石
6613423,//钛钽铌矿石
6613424,//钒矿石
6613425,//锆矿石
6613426,//其他未列明有色金属矿石
6613348,//非金属矿石
6613427,//石灰石、石膏类
6613439,//石灰石
6613440,//石膏类
6613428,//建筑用天然石料
6613441,//天然大理石荒料
6613442,//天然花岗石荒料
6613443,//石英岩
6613444,//砂岩
6613445,//板岩
6613446,//蜡石
6613447,//其他建筑用天然石料
6613429,//耐火土石类
6613448,//耐火粘土
6613449,//耐火粘土熟料
6613450,//铁铝矾土
6613451,//白云岩
6613452,//煅烧白云石
6613453,//红柱石
6613454,//蓝晶石
6613455,//夕线石
6613456,//其他耐火土石类
6613430,//粘土、砂、石
6613457,//煅烧高岭土
6613458,//硅质土
6613459,//建筑用砂、土
6613460,//其他砂石骨料
6613461,//干化污泥
6613462,//以自己采掘的砂、土、石料或其他矿物连续生产的砖、瓦、石灰（不含粘土实心砖、瓦）
6613431,//化学矿石
6613463,//硫铁矿石
6613464,//磷矿石
6613465,//钾矿石
6613466,//硼矿石
6613467,//硫磺矿石
6613468,//萤石
6613469,//重晶石
6613470,//毒重石
6613471,//冰晶石
6613472,//冰洲晶石
6613473,//硫镁矾矿石
6613474,//蛇纹石
6613475,//天青石
6613476,//天然碱
6613477,//芒硝矿石
6613478,//天然硝石
6613479,//明矾石
6613480,//砷矿石
6613481,//其他化学矿石
6613432,//原盐
6613482,//海盐
6613483,//湖盐
6613484,//井矿盐
6613485,//其他原盐
6613433,//石棉
6613434,//云母
6613435,//天然石墨
6613436,//滑石
6613437,//宝石、玉石矿石
6613486,//天然宝石类矿石
6613487,//天然玉石类矿石
6613488,//彩石类矿石
6613438,//其他非金属矿石
6613349,//其他矿产品
6611508,//食品、饮料、烟、酒类产品
6613489,//农副食品，动、植物油制品
6613712,//谷物细粉
6613752,//小麦粉
6613753,//大米粉
6613754,//其他谷物细粉
6613731,//碾磨谷物及谷物加工
6613755,//碾磨、脱壳谷物
6613786,//大米
6613787,//小米
6613789,//糯米
6613790,//高粱米
6613792,//脱壳燕麦
6613793,//脱壳青稞
6613794,//珠粒大麦
6613795,//其他碾磨、脱壳谷物
6613764,//粗磨谷物
6613765,//谷物加工制品
6613732,//薯、豆，相关植物加工品
6613767,//薯类及类似植物加工品
6613768,//干豆粉
6613769,//水果、坚果粉
6613770,//其他植物加工品
6613733,//饲料及宠物食品
6613772,//饲料
6613773,//饲料添加剂
6613774,//动物源性饲料
6613776,//饲料用植物根粉
6613777,//饲料用水产品渣粉
6613778,//豆粕
6613734,//植物油及其制品
6613800,//食用植物油及食用植物油脂
6613804,//大豆油
6613806,//棕榈油
6613807,//菜籽油
6613808,//其他食用植物油
6613809,//食用植物油脂
6613801,//非食用植物油
6613811,//茴油、毛椰子油
6613812,//其他非食用植物油
6613802,//植物油分离制品
6613803,//植物油脂加工产品
6613735,//糖、加工糖及制糖副产品
6613814,//原糖
6613815,//成品糖
6613816,//加工糖
6613817,//制糖副产品
6613737,//畜禽肉、油脂及食用杂碎
6613824,//鲜、冷、冻肉
6613841,//猪、牛、羊、鸡、鸭、鹅鲜、冷、冻肉
6613842,//其他鲜、冷、冻肉
6613825,//动物肠衣
6613827,//可食用动物杂碎
6613828,//动物油脂及加工制品
6613830,//动物精及汁
6613738,//熟肉制品
6613868,//蒸煮香肠制品
6613869,//熏肉制品
6613870,//酱卤烧烤肉制品
6613871,//腌腊肉制品
6613872,//干炸肉制品
6613873,//其他熟肉制品
6613739,//水产加工品
6613874,//冷冻水产品
6613875,//干制水产品
6613876,//腌渍水产品
6613877,//熏制水产品
6613878,//鱼糜（熟肉）制品
6613879,//甲壳水产品加工品
6613880,//水产品精、汁制品
6613881,//水产品油脂制品
6613882,//其他水产加工品
6613741,//蔬菜加工品
6613883,//冷冻蔬菜
6613884,//暂时保藏蔬菜（原料）
6613885,//干制蔬菜（脱水蔬菜）
6613886,//腌渍菜
6613742,//水果、坚果加工品
6613887,//冷冻水果及坚果
6613888,//水果酱
6613889,//坚果酱
6613890,//果泥
6613891,//果膏及类似制品
6613892,//果核及核仁
6613893,//焙、炒加工坚果及果仁
6613894,//蒸煮加工坚果及果仁
6613895,//暂时保藏水果及坚果（原料）
6613896,//其他水果、坚果加工品
6613743,//淀粉及淀粉制品
6613897,//淀粉
6613898,//小麦淀粉
6613899,//玉米淀粉
6613900,//马铃薯淀粉
6613901,//其他淀粉
6613902,//菊粉
6613903,//淀粉制品
6613904,//淀粉糖
6613905,//面筋
6613906,//糊精及改性淀粉
6613907,//其他淀粉及淀粉制品
6613745,//豆腐及豆制品
6613908,//水豆腐
6613909,//豆制品
6613910,//豆浆及豆浆粉
6613747,//蛋制品
6613912,//鸡鸭鹅蛋品
6613913,//其他蛋品
6613914,//再制蛋
6613915,//卵清蛋白
6613749,//植物蛋白
6613750,//微生物蛋白
6613751,//其他农副食品
6613490,//食品及加工盐
6613919,//焙烤食品
6613936,//糕点
6613938,//面包
6613939,//饼干
6613940,//膨化食品
6613942,//焙烤松脆食品
6613945,//其他焙烤食品
6613920,//糖果、巧克力、蜜饯及类似食品
6613948,//糖果
6613949,//巧克力
6613951,//巧克力制品
6613952,//代可可脂巧克力
6613953,//代可可脂巧克力制品
6613954,//蜜饯
6613955,//果冻及果冻罐头
6613956,//果冻
6613957,//果冻罐头
6613921,//方便食品
6613958,//米、面制半成品
6613959,//速冻食品
6613960,//即食方便食品
6613922,//乳制品
6613961,//液体乳
6613962,//固体及半固体乳制品
6613924,//罐头
6613967,//畜肉类罐头
6613968,//禽肉类罐头
6613988,//水产动物类罐头
6613990,//蔬菜类罐头
6613991,//水果类罐头
6613992,//果酱类罐头
6613993,//干果和坚果类罐头
6613994,//谷物制品类罐头
6613995,//豆类制品罐头
6613996,//汤类罐头
6613997,//调味类罐头
6613998,//混合类罐头
6613999,//婴幼儿辅助食品类罐头
6614000,//其他罐头
6613925,//调味品
6614002,//味精（谷氨酸钠）
6614004,//酱油及酱类制品
6614005,//醋及醋代用品
6614006,//复合调味品
6613927,//发酵类制品
6614013,//酵母
6614014,//食品用氨基酸
6614015,//柠檬酸及其盐和酸酯
6614017,//食品用发酵有机酸
6614018,//食品用酶制剂
6613929,//营养、保健食品
6614019,//婴幼儿用均化食品
6614020,//营养配餐食品
6614021,//蜂蜜营养制品
6614022,//其他营养、保健食品
6613930,//冷冻饮品
6614023,//冰淇淋
6614024,//雪糕类
6614025,//冰棍
6614026,//甜味冰
6614028,//雪泥
6614029,//食用冰
6614030,//其他冷冻饮品
6613931,//加工盐
6614032,//食用盐
6614033,//非食用盐
6613932,//食品添加剂
6614034,//木糖
6614035,//其他食品添加剂
6613933,//食品用类似原料
6614036,//食品用原料粉
6614037,//饮料用原料
6614038,//植物液汁及浸膏
6614039,//糯米纸
6614040,//其他食品用类似原料
6613934,//其他食品
6613491,//饮料、酒及酒精
6614041,//酒精
6614050,//木质水解酒精
6614051,//其他酒精
6614042,//白酒
6614043,//啤酒
6614052,//每吨不超过3000元的啤酒
6614053,//每吨3000元（含）以上的啤酒
6614044,//黄酒
6614045,//葡萄酒
6614046,//其他酒
6614047,//软饮料
6614055,//碳酸型饮料（汽水）
6614056,//果汁和蔬菜汁类饮料
6614057,//蛋白饮料
6614058,//包装饮用水
6614059,//茶饮料
6614060,//咖啡饮料
6614061,//固体饮料
6614062,//其他软饮料
6614048,//精制茶及茶制品
6614066,//精制茶
6614067,//茶制品
6614068,//边销茶
6614049,//饮料、酒及酒精专用原辅料
6614069,//酒及酒精专用原辅料
6614070,//饮料专用原辅料
6613492,//烟草制品
6614071,//复烤烟叶
6614072,//片烟
6614073,//烟梗
6614074,//卷烟
6614075,//甲类卷烟
6614076,//乙类卷烟
6614077,//烟草代用品制的卷烟
6614078,//雪茄烟
6614079,//烟草制的雪茄烟
6614080,//烟草代用品制的雪茄烟
6614081,//烟丝
6611689,//纺织、服装、皮革类产品
6614082,//纺织产品
6614086,//棉、化纤纺织及印染产品
6614101,//已梳皮棉
6614102,//纱
6614103,//线
6614104,//缝纫线
6614105,//布
6614106,//印染布
6614087,//毛纺织、染整加工产品
6614108,//毛条
6614109,//毛纱
6614110,//绒线
6614111,//毛机织物（呢绒）
6614112,//特种羊毛或动物细毛织物
6614113,//毛染整精加工产品
6614088,//麻纺织品
6614114,//麻纤维原料
6614115,//麻纱线
6614116,//亚麻布
6614120,//亚麻印染布
6614121,//苎麻布
6614122,//苎麻印染布
6614123,//黄红麻织物
6614124,//大麻织物
6614125,//其他麻纺织品
6614089,//丝绢纺织及精加工产品
6614127,//蚕丝
6614128,//蚕丝及交织机织物
6614130,//印染蚕丝及交织机织物
6614131,//化纤长丝机织物
6614132,//特种丝织物
6614090,//床上用织物制品
6614133,//床上用织物制品
6614134,//床褥单
6614135,//被面
6614136,//枕套
6614137,//被罩
6614138,//床罩
6614139,//毯子
6614140,//寝具及类似填充用品
6614141,//毛巾被
6614142,//枕巾
6614143,//其他床上用织物制品
6614091,//日用织物制品
6614145,//台布（桌布）
6614146,//毛巾
6614147,//餐桌、盥洗及厨房用织物制品
6614148,//窗帘及类似品
6614149,//垫子套
6614150,//安全用织物制品
6614151,//其他纺织制品
6614092,//毡呢、包装用织物制品
6614152,//毡呢
6614153,//包装用织物制品
6614093,//油苫布、天篷、遮阳篷及类似品
6614154,//油苫布
6614155,//天篷
6614156,//遮阳篷
6614157,//帐篷
6614158,//篷房
6614159,//风帆
6614160,//充气褥垫
6614161,//野营用织物制品
6614162,//降落伞、旗帜及类似品
6614094,//纤维纺制线、绳、索、缆
6614163,//纤维纺制绳、缆
6614164,//网类制品
6614165,//吊装绳索具
6614166,//绳梯类制品
6614167,//其他纤维纺制线、绳、索、缆
6614095,//浸渍、涂布或包覆处理纺织物
6614168,//帘子布
6614169,//纺织材料制传输带
6614170,//用塑料处理纺织物
6614171,//涂胶或淀粉纺织物
6614172,//涂焦油、蜡、沥青或类似产品纺织物
6614173,//硬挺纺织物
6614174,//狭幅机织物
6614096,//无纺布及其制品
6614175,//无纺布（无纺织物）
6614176,//无纺织物制品
6614097,//针织、编织物
6614177,//经编织物
6614178,//纬编制物
6614179,//针织或钩编起绒织物
6614180,//针织钩编织物（针织坯布）
6614098,//针织、编织制品
6614181,//针织或钩编床罩
6614182,//针织或钩编相关床上制品
6614183,//针织或钩编台布
6614184,//针织或钩编相关餐桌用制品
6614185,//针织或钩编窗帘及类似品
6614186,//针织袜
6614187,//针织手套
6614099,//围巾、领带、手帕
6614188,//围巾类
6614189,//领带
6614190,//手帕
6614100,//其他纺织产品
6614191,//纺织材料絮胎及其制品
6614192,//纺织材料制标签、徽章及类似品
6614193,//成匹编带、装饰带及类似品
6614194,//网眼薄纱，相关网眼织物
6614195,//图案花边
6614196,//供技术用途纺织品
6614197,//其他未列明纺织产品
6614083,//服装、鞋、帽
6614198,//服装
6614203,//女内衣
6614204,//男内衣
6614205,//女睡衣
6614206,//男睡衣
6614207,//女浴衣
6614209,//男浴衣
6614210,//女衬衫
6614234,//男衬衫
6614235,//女Ｔ恤衫
6614236,//男Ｔ恤衫
6614237,//女上衣
6614238,//男上衣
6614239,//女裤子
6614240,//男裤子
6614241,//裙子
6614242,//女大衣、女风衣
6614243,//男大衣、男风衣
6614244,//便服套装
6614245,//西服套装
6614246,//女毛衣
6614247,//男毛衣
6614248,//防寒服
6614249,//运动服装
6614250,//婴幼儿服装
6614251,//特种服装
6614252,//其他服装
6614199,//皮革服装
6614253,//天然皮革服装
6614255,//毛皮服装
6614256,//毛皮服装附件
6614254,//非天然皮革服装
6614200,//毛皮服装及其附件
6614257,//毛皮服装
6614258,//毛皮服装附件
6614201,//鞋
6614259,//皮革鞋靴
6614260,//纺织面鞋
6614261,//胶鞋
6614262,//塑料鞋
6614263,//木制鞋
6614264,//舞蹈、戏剧用靴鞋
6614265,//靴鞋零件、护腿及类似品
6614266,//其他鞋
6614202,//帽子及附件
6614267,//帽子
6614268,//帽子附件
6614084,//皮革、毛皮及其制品
6614269,//半成品革
6614270,//成品革和再生革
6614276,//成品革
6614277,//再生皮革
6614271,//箱、包及类似容器
6614278,//衣箱、提箱及类似容器
6614279,//手提包（袋）、背包
6614291,//皮革作面类似箱、包容器
6614292,//塑料作面类似箱、包容器
6614293,//纺织材料作面类似箱、包容器
6614294,//其他箱、包及类似容器
6614272,//皮手套及皮革制衣着附件
6614295,//皮革手套
6614296,//毛皮手套
6614297,//皮革制衣着附件
6614273,//钱包、座套，相关皮革制品
6614299,//钱包及类似物品
6614300,//皮革制座套
6614302,//专门技术用途皮革制品
6614303,//鞍具及挽具
6614304,//其他相关皮革制品
6614274,//鞣制毛皮、人造毛皮及其制品
6614305,//鞣制毛皮
6614306,//已缝制整张毛皮及其块、片
6614307,//天然毛皮制品
6614308,//人造毛皮
6614309,//人造毛皮制品
6614275,//加工羽毛（绒）
6614311,//加工填充用羽毛
6614312,//加工填充用羽绒
6611691,//木制品、家具类产品
6614315,//木材及木、竹、藤、棕、草制品
6614317,//锯材
6614327,//普通锯材
6614328,//特种锯材
6614329,//枕木
6614331,//其他锯材
6614318,//木片、木粒加工产品
6614332,//木片、木粒
6614333,//木丝、木粉
6614334,//锯末、木废料及碎片
6614319,//人造板
6614335,//胶合板
6614336,//纤维板
6614337,//刨花板
6614338,//细木工板
6614339,//其他人造板
6614320,//二次加工材，相关板材
6614415,//单板
6614416,//强化木
6614417,//指接材
6614418,//人造板表面装饰板
6614419,//热固性树脂装饰层压板
6614321,//建筑用木料及加工木材组件
6614458,//木制门及其框架和门槛
6614459,//木制窗及其木制框架
6614460,//木模
6614461,//木制地板
6614471,//实木地板
6614472,//其他木制地板
6614462,//木瓦
6614463,//木制盖屋板
6614464,//木制梁、椽、屋顶支梁
6614465,//木制楼梯
6614469,//其他建筑用木料及加工木材组件
6614322,//木容器
6614479,//木制桶、槽、盆及类似容器
6614481,//包装用木容器
6614482,//木质保温容器
6614484,//木托板、箱形托盘及类似装载木板
6614323,//软木及软木制品
6614485,//天然软木
6614486,//软木制品
6614487,//压制软木及其制品
6614324,//木制餐具，相关木制品
6614488,//木制餐具及厨房用具
6614489,//木制一次性筷子
6614490,//木质框架，相关木制品
6614325,//竹制品
6614491,//竹制工业、建筑用品
6614492,//竹制包装用品
6614493,//竹制炊事用具
6614494,//竹编结制品，相关竹制品
6614326,//棕、藤、草及类似制品
6614495,//棕制品
6614496,//藤制品
6614497,//柳（荆）条制品
6614498,//苇制品
6614499,//草制品
6614500,//玉米皮制篮筐，类似编结品
6614501,//其他棕、藤、草及类似制品
6614316,//家具及配件
6614503,//家具
6614506,//木质家具
6614575,//竹家具
6614576,//藤家具
6614579,//金属家具
6614580,//塑料家具
6614581,//软体家具
6614582,//玻璃、玻璃纤维增强塑料家具
6614584,//石头、陶瓷制家具
6614585,//其他家具
6614504,//家具配件
6614587,//木质家具零配件
6614588,//竹家具零配件
6614589,//藤家具零配件
6614590,//金属家具零配件
6614591,//塑料家具零配件
6614592,//软体家具零配件
6614593,//玻璃家具零配件
6614594,//坐具零配件
6614595,//其他家具配件
6611692,//纸、印刷品、软件、文教、工艺品类产品
6614596,//纸及纸制品
6614601,//纸浆
6614612,//木浆
6614613,//非木材纤维纸浆
6614614,//废纸纸浆
6614615,//化学溶解浆
6614616,//秸秆浆
6614617,//再生纸浆
6614618,//其他纸浆
6614602,//机制纸及纸板
6614619,//未涂布印刷书写用纸
6614620,//涂布类印刷用纸
6614621,//卫生用纸原纸
6614622,//包装用纸及纸板
6614623,//感应纸及纸板
6614624,//纤维类过滤纸及纸板
6614625,//其他机制纸及纸板
6614603,//加工纸
6614626,//美纹、穿孔纸及纸板
6614627,//转印纸
6614628,//油印蜡纸或胶印版纸
6614629,//涂布浸渍覆盖纸
6614631,//瓦楞纸板
6614632,//其他加工纸
6614604,//手工制纸及纸板
6614633,//手工纸
6614634,//手工纸板
6614605,//纸制品
6614635,//纸和纸板制容器
6614636,//纸制文具及用品
6614637,//纸浆模制品
6614638,//卫生用纸制品
6614639,//纸制壁纸、窗纸、铺地制品及类似品
6614640,//纸浆制滤块、滤板及滤片
6614641,//纸或纸板制标签
6614642,//纸制筒管、卷轴、纡子及类似品
6614643,//神纸及类似用品
6614644,//纸扇
6614645,//箱板纸
6614646,//其他纸制品
6614597,//印刷品、记录媒介复制品
6614648,//印刷品
6614654,//有刊号图书、报纸、期刊类印刷品
6614663,//党报
6614664,//党刊
6614665,//机关报刊、机关期刊
6614667,//盲文图书和盲文期刊
6614668,//少数民族文字出版物
6614669,//特定地区出版物
6614670,//特定图书、报纸和期刊
6614671,//少年儿童报刊及课本
6614672,//老年报刊
6614674,//其他有刊号图书、报纸、期刊类印刷品
6614655,//无刊号图书、报纸、期刊类印刷品
6614656,//广告宣传印刷品
6614657,//地图、地图册
6614658,//图片、设计图样及照片
6614659,//票证
6614660,//明信片、卡片、日历、挂历
6614661,//其他印刷品
6614649,//本册
6614675,//用于书写本册
6614676,//其他本册
6614650,//印刷用附件
6614652,//磁介质复制品
6614678,//录音带复制品
6614680,//录像带复制品
6614681,//软磁盘复制品
6614682,//其他磁介质复制品
6614653,//非磁介质复制品
6614684,//唱片复制品
6614685,//光盘复制品
6614687,//非音像复制品
6614688,//电影胶片拷贝
6614689,//其他非磁介质复制品
6614598,//软件、电子出版物
6614690,//软件产品
6614693,//基础软件产品
6614696,//系统软件产品
6614697,//数据库软件产品
6614698,//中间件软件产品
6614699,//其他基础软件产品
6614694,//应用软件产品
6614700,//通用应用软件
6614701,//行业应用软件产品
6614702,//游戏软件产品
6614703,//动漫软件产品
6614704,//地理信息软件产品
6614705,//语言处理软件产品
6614706,//其他应用软件产品
6614695,//嵌入式软件产品
6614707,//通信设备嵌入式软件
6614708,//网络设备嵌入式软件
6614709,//数字装备设备嵌入式软件
6614710,//数字视频产品嵌入式软件
6614711,//自动控制产品嵌入式软件
6614712,//汽车电子嵌入式软件
6614713,//其他嵌入式软件
6614691,//电子出版物
6614599,//文教体育用品
6614715,//文具及类似用品
6614735,//文具盒（袋）
6614737,//文件夹
6614738,//文件架
6614739,//装订类文具
6614741,//夹具类文具
6614742,//修正液
6614744,//橡皮
6614746,//浆糊
6614747,//胶水
6614748,//固体胶
6614749,//文印类用品
6614750,//画具及类似用品
6614753,//其他文具及类似用品
6614716,//笔及其零件
6614755,//笔
6614757,//自来水笔
6614758,//圆珠笔
6614760,//铅笔
6614761,//绘画笔
6614763,//记号笔
6614764,//专业用笔
6614756,//笔配件和零件
6614720,//教具及类似用具
6614766,//教学用模型
6614768,//教学用标本
6614769,//具有书写或绘画面板类教具
6614770,//教学或学生绘图用具、量具及类似器具
6614771,//其他教具及类似用具
6614722,//墨水
6614772,//普通墨水
6614773,//专用墨水
6614723,//墨汁及类似品
6614774,//墨汁
6614775,//墨汁类似品
6614725,//体育用品
6614776,//运动用球
6614777,//运动用球类器材及器械
6614779,//体育器材及配件
6614780,//室内训练健身器材
6614781,//室外健身器材
6614782,//运动防护用具
6614783,//钓鱼用品和器材
6614787,//休闲运动器材和用品
6614788,//其他体育用品
6614726,//乐器、乐器辅助用品及零件
6614791,//中乐器
6614792,//西乐器
6614794,//电子乐器
6614795,//媒诱音响器，相关乐器
6614797,//乐器辅助用品及零件
6614728,//玩具
6614799,//供儿童乘骑带轮玩具
6614800,//填充类玩具
6614802,//玩偶及其零配件和装饰品
6614803,//仿真模型及其附件
6614804,//木制玩具
6614805,//塑胶玩具
6614806,//玩具乐器
6614808,//儿童娱乐塑形用膏、泥
6614809,//其他玩具
6614731,//游乐场设备
6614810,//电动游乐设备
6614811,//非电动游乐设备
6614813,//其他游乐场设备
6614732,//游艺用品及室内游艺器材
6614814,//电子游戏机
6614815,//投币式游戏机
6614817,//台球器材及配件
6614829,//保龄球设备及器材
6614831,//沙狐球桌及其配套器材
6614832,//桌式足球器材及配件
6614833,//飞镖器材及配件
6614834,//棋类娱乐用品
6614835,//牌类娱乐用品
6614836,//专供游戏用家具式桌子
6614837,//其他游艺用品及室内游艺器材
6614600,//工艺品及其他制造产品
6614838,//雕塑工艺品
6614852,//雕刻工艺品
6614853,//塑造工艺品
6614855,//其他雕塑工艺品
6614839,//金属工艺品
6614863,//景泰蓝工艺品
6614864,//珐琅珀晶工艺品
6614866,//银蓝工艺品
6614867,//贵金属摆件
6614869,//铜制工艺品
6614870,//铁制工艺品
6614872,//锡制工艺品
6614873,//金属制民间刀剑工艺品
6614874,//金属丝编织工艺品
6614876,//金属制艺术标牌及类似品
6614877,//蒙镶工艺品
6614879,//金属制工艺框架类制品
6614880,//其他金属工艺品
6614840,//漆器工艺品
6614883,//镶嵌漆器工艺品
6614884,//雕漆漆器工艺品
6614885,//脱胎漆器工艺品
6614887,//彩绘雕填漆器工艺品
6614888,//漆线雕工艺品
6614890,//刻灰漆器工艺品
6614891,//漆画工艺品
6614893,//漆器工艺框架类制品
6614895,//其他漆器工艺品
6614841,//花画工艺品
6614921,//人造花类工艺品
6614922,//画类工艺品
6614842,//天然植物纤维及人造纤维编织工艺品
6614923,//天然植物纤维编织工艺品
6614924,//人造纤维编织工艺品
6614843,//抽纱刺绣工艺品
6614925,//刺绣工艺品
6614926,//抽纱工艺品
6614927,//手工编结工艺品
6614928,//手工染织工艺品及机织工艺品
6614929,//工艺织锦
6614930,//其他抽纱刺绣工艺品
6614844,//地毯、挂毯类工艺品
6614931,//手工地毯、挂毯
6614932,//机制地毯、挂毯
6614845,//陈设艺术陶瓷制品
6614933,//室内陈设艺术陶瓷制品
6614934,//工艺陶瓷制品
6614935,//陶瓷壁画
6614936,//陶瓷制塑像
6614937,//其他陈设艺术陶瓷制品
6614846,//珠宝首饰
6614938,//金银珠宝首饰
6614939,//珠宝玉石
6614941,//已加工钻石
6614942,//未加工钻石
6614943,//其他珠宝玉石
6614940,//其他珠宝首饰
6614847,//剧装道具，相关工艺美术品
6614944,//剧装、道具
6614945,//发制品及其专用原料
6614954,//合成纺织材料制假发
6614955,//档发
6614956,//人发制假发
6614957,//人体毛发装饰用品
6614958,//发制品及类似品专用原料
6614946,//民间工艺品
6614947,//工艺扇
6614948,//工艺伞
6614949,//灯彩
6614950,//料器
6614951,//美术人形
6614952,//节庆庆典用品及相关娱乐用品
6614953,//其他相关工艺美术品
6614848,//保健休闲用品
6614959,//桑拿浴箱
6614960,//排汗活动机
6614961,//熏蒸足道机
6614962,//养生桑拿蒸汽机
6614963,//养生美体美容仪
6614964,//养生理疗枕
6614965,//养生塑身机
6614966,//养生制氧机
6614967,//养生水氧吧
6614968,//Spa水疗机
6614969,//Spa气泡按摩机
6614970,//Spa精油温灸仪
6614971,//高温竹炭制品
6614972,//其他保健休闲用品
6614850,//日用杂品
6614973,//镜子类制品及零配件
6614974,//刷子类制品
6614975,//已加工刷类制品材料
6614976,//清洁清扫类工具及其已加工材料
6614977,//伞、手杖、鞭子、马鞭及其零件
6614978,//拉链及其零件
6614979,//扣类制品及其零件
6614980,//打火机及其零件
6614981,//烟具
6614982,//头发装饰用物品
6614983,//香水喷射器、粉扑及粉拍
6614984,//礼仪电子用品
6614985,//棉胎
6614986,//居民用煤制品
6614987,//其他日用杂品
6614851,//宠物用品
6614988,//宠物玩具
6614989,//宠物服装
6614990,//宠物消毒用品
6614991,//宠物专用品
6611694,//石油、化工、医药产品
6614992,//石油加工、炼焦及核燃料
6614998,//石油制品
6615043,//汽油
6615044,//航空汽油
6615045,//车用汽油
6615046,//其他汽油
6615047,//煤油
6615048,//航空煤油
6615049,//其他煤油
6615050,//柴油
6615051,//燃料油
6615052,//石脑油
6615053,//溶剂油
6615054,//润滑油
6615055,//润滑脂
6615056,//润滑油基础油
6615057,//液体石蜡
6615058,//石油气，相关烃类气石油气
6615059,//其他石油气和相关烃类气
6615060,//矿物蜡及合成法制类似产品
6615061,//油类残渣
6615062,//其他石油制品
6614999,//人造能源产品
6615064,//页岩原油
6615065,//生物能源
6615506,//生物燃油
6615508,//生物柴油
6615510,//生物丁醇
6615511,//沼气
6615516,//生物氢气
6615517,//生物质致密成型燃料
6615518,//生物炭
6615519,//其他生物能源
6615278,//合成液体燃料
6615520,//乙醇汽油
6615521,//甲醇汽油
6615522,//其他合成液体燃料
6615000,//焦炭及其副产品
6615523,//焦炭
6615524,//矿物焦油
6615525,//石油焦、碳黑
6614993,//化学原料及化学制品
6615526,//无机基础化学原料
6615558,//无机酸类
6615618,//硫酸类
6615619,//其他无机酸
6615559,//非金属无机氧化物
6615621,//粉煤灰
6615622,//其他非金属无机氧化物
6615561,//过氧化氢（双氧水）
6615562,//非金属卤化物及硫化物
6615563,//烧碱
6615564,//纯碱类
6615565,//金属氢氧化物
6615593,//金属氧化物
6615595,//金属过氧化物、超氧化物
6615596,//金属硫化物及硫酸盐
6615597,//金属硝酸盐、亚硝酸盐
6615599,//金属氧化物酸盐、金属过氧化物酸盐
6615601,//磷化物、金属磷酸盐
6615602,//氟化物及其盐
6615603,//氯化物及其盐
6615605,//氯氧化物及氢氧基氯化物
6615606,//溴化物及其盐
6615607,//碘化物及其盐
6615609,//氰化物、氧氰化物及氰络合物
6615610,//硅化物及硅酸盐
6615611,//硼化物、硼酸盐和过硼酸盐
6615612,//碳化物及碳酸盐
6615613,//氧化铁
6615614,//铝酸钠
6615616,//铝酸三钙
6615527,//有机化学原料
6615623,//无环烃
6617290,//甲烷
6617291,//乙烯
6617292,//丙烯
6617293,//丁二烯
6617295,//其他无环烃
6615624,//环烃
6617297,//芳香烃
6617299,//纯苯
6617300,//甲苯
6617301,//邻二甲苯、间二甲苯、对二甲苯、混合二甲苯
6617303,//其他芳香烃
6617304,//其他环烃
6615626,//无环烃饱和氯化衍生物
6617244,//无环烃不饱和氯化衍生物
6617245,//无环烃氟化、溴化或碘化衍生物
6617246,//含不同卤素无环烃卤化衍生物
6617247,//芳香烃卤化衍生物
6617248,//烃磺化、硝化或亚硝化衍生物
6617250,//无环醇及其衍生物
6617251,//环醇
6617252,//酚
6617253,//酚及酚醇衍生物
6617254,//羧酸及其衍生物
6617256,//氨基化合物
6617258,//含氮基化合物
6617259,//醚
6617261,//醚醇
6617262,//醚酚及醚醇酚
6617264,//过氧化醇、过氧化醚及过氧化酮
6617265,//醛
6617266,//醛醇
6617267,//醛醚、醛酚及含有相关含氧基醛
6617269,//环聚醛
6617270,//多聚甲醛
6617271,//酮
6617272,//酮醇、酮醛及酮酚
6617273,//醌基化合物
6617274,//无机酸酯及其盐
6617275,//亚磷酸酯
6617277,//亚硝酸酯及硝酸酯
6617278,//碳酸酯、过碳酸酯及其盐
6617279,//硅酸酯及其盐
6617280,//镍钴锰氢氧化物
6617282,//镍钴锰酸锂
6617283,//硫酸铵
6617284,//氯化钴
6617285,//活性硅酸钙
6617286,//环氧环己烷
6617287,//正戊醇
6617288,//二甲醚
6615528,//贵金属化合物、相关基础化学品
6617309,//活性炭、硫磺、磷
6617317,//活性炭
6617318,//硫磺
6617319,//磷
6617310,//非金属基础化学品
6617311,//贵金属化合物
6617312,//稀土化合物
6617314,//氢化物、氮化物、叠氮化物
6617315,//气体及稀有气体
6617316,//有机－无机化合物
6615529,//化学肥料
6617324,//氨及氨水
6617325,//氮肥
6617326,//磷肥
6617327,//钾肥
6617328,//中量元素肥料
6617329,//微量元素肥料
6617330,//复合肥、复混合肥
6615530,//有机肥料及微生物肥料
6617331,//有机肥料
6617332,//微生物肥料
6617334,//动物、植物肥料
6615531,//化学农药
6615533,//生物农药及微生物农药
6615534,//涂料
6615535,//油墨及类似产品
6615536,//颜料
6615537,//染料类
6615538,//密封用填料及类似品
6615540,//化学合成材料
6615541,//化学试剂和助剂
6615542,//专项化学用品
6615544,//林产化学产品
6615546,//炸药、烟火及火工产品
6615547,//信息化学品
6615548,//环境污染处理专用药剂材料
6615549,//动物炭黑、动物胶及其衍生物
6615550,//焊接用制品
6615551,//肥皂及合成洗涤剂
6615552,//美容、护肤、护发产品
6615553,//口腔清洁护理用品
6615554,//香料
6615555,//香精
6615557,//其他化学制品
6614994,//医药
6614995,//化学纤维
6614996,//橡胶制品
6614997,//塑料制品、半成品及辅料
6611696,//金属及非金属制品
6611697,//机械、设备类产品
6611698,//电力、热力、水、燃气类产品
6611495,//销售服务
6611704,//建筑服务
6612518,//工程服务
6612543,//安装服务
6612546,//修缮服务
6612547,//装饰服务
6612550,//其他建筑服务
6611705,//邮政服务
6611706,//电信服务
6611707,//现代服务
6612636,//研发和技术服务
6612645,//研发服务
6612646,//技术咨询服务
6612647,//合同能源管理服务
6612648,//工程勘察勘探服务
6612649,//工程勘察服务
6612650,//地质勘查服务
6612652,//矿产地质勘查服务
6612653,//基础地质勘查服务
6612654,//其他地质勘查服务
6612651,//专业技术服务
6612655,//专业技术服务
6612637,//信息技术服务
6612657,//软件服务
6612658,//软件开发服务
6612659,//软件咨询服务
6612660,//软件维护服务
6612661,//软件测试服务
6612662,//其他软件服务
6612663,//电路设计及测试服务
6612665,//电路设计服务
6612666,//电路测试服务
6612667,//相关电路技术支持服务
6612668,//信息系统服务
6612669,//业务流程管理服务
6612670,//信息系统增值服务
6612638,//文化创意服务
6612676,//设计服务
6612677,//工程设计服务
6612678,//专业设计服务
6612679,//文印晒图服务
6612680,//其他设计服务
6612681,//知识产权服务
6612682,//广告服务
6612683,//广告发布服务
6612685,//影视、广播广告发布服务
6612686,//报纸、杂志广告发布服务
6612687,//灯箱广告发布服务
6612688,//路牌广告发布服务
6612689,//建筑物广告发布服务
6612690,//互联网广告发布服务
6612691,//流动广告发布服务
6612692,//其他广告发布服务
6612684,//广告代理服务
6612693,//会议展览服务
6612795,//会议服务
6612796,//展览服务
6612639,//物流辅助服务
6612806,//航空服务
6612859,//航空地面服务
6612872,//机场服务
6612874,//空中交通管理服务
6612875,//其他航空地面服务
6612871,//通用航空服务
6612877,//航空摄影
6612878,//航空培训
6612879,//航空测量
6612880,//航空勘探
6612882,//航空护林
6612883,//航空播洒农药
6612884,//航空降雨
6612885,//其他通用航空服务
6612886,//港口码头服务
6612887,//客运港口码头服务
6612891,//货运港口码头服务
6612892,//其他港口码头服务
6612893,//货运客运场站服务
6612894,//铁路货运客运场站服务
6612895,//道路货运客运场站服务
6612897,//打捞救助服务
6612898,//货物运输代理服务
6612900,//国内货物运输代理服务
6612901,//国际货物运输代理服务
6612902,//港澳台货物运输代理服务
6612903,//代理报关服务
6612904,//仓储服务
6612905,//农产品仓储服务
6612907,//专业仓储服务
6612908,//运输货场仓储服务
6612909,//商业流通仓储服务
6612910,//其他仓储服务
6612912,//装卸搬运服务
6612914,//收派服务
6612915,//收件服务
6612916,//分拣服务
6612917,//派送服务
6612640,//租赁服务
6612926,//融资租赁服务
6612928,//有形动产融资租赁服务
6612929,//有形动产融资租赁售后回租服务
6612930,//不动产融资租赁服务
6612933,//其他融资租赁服务
6612934,//经营租赁
6612936,//有形动产经营租赁服务
6612938,//光租业务
6612939,//干租业务
6612940,//其他有形动产经营租赁服务
6612937,//不动产经营租赁
6612941,//住宅经营租赁服务
6612944,//公共住房租赁
6612945,//个人出租住房
6612946,//其他住房租赁服务
6612949,//车辆停放服务
6612950,//道路通行服务
6612951,//高速公路通行服务
6612952,//江河等闸口通行服务
6612953,//桥梁通行服务
6612954,//其他道路通行服务
6612955,//商业营业用房经营租赁服务
6612957,//其他不动产经营租赁服务
6612958,//军队空余房产租赁服务
6612959,//其他情形不动产经营租赁服务
6612960,//鉴证咨询服务
6612641,//鉴证咨询服务
6612961,//认证服务
6612962,//鉴证服务
6612964,//工程监理服务
6612965,//其他鉴证服务
6612963,//咨询服务
6612642,//广播影视服务
6612966,//广播影视节目（作品）的制作服务
6612969,//广播节目制作服务
6612977,//电视节目制作服务
6612978,//电影制作服务
6612979,//音像制作服务
6612967,//广播影视节目（作品）的发行服务
6612980,//广播节目发行服务
6612981,//电视节目发行服务
6612982,//电影发行服务
6612968,//广播影视节目（作品）的播映（含放映）服务
6612985,//广播节目播出服务
6612986,//电视节目播出服务
6612987,//电影放映服务
6612988,//现场电影放映服务
6612989,//互联网电影播出服务
6612643,//商务辅助服务
6612991,//企业管理服务
6612997,//物业管理服务
6612998,//其他企业管理服务
6612992,//经纪代理服务
6612999,//货物运输代理服务
6613001,//货物运输代理服务
6613004,//国内货物运输代理服务
6613005,//国际货物运输代理服务
6613006,//港澳台货物运输代理服务
6613012,//其他货物运输代理服务
6613013,//代理报关服务
6613014,//婚姻介绍服务
6613016,//人力资源外包服务
6613017,//其他经纪代理服务
6612993,//人力资源服务
6613035,//劳务派遣服务
6613036,//其他人力资源服务
6612996,//安全保护服务
6612644,//其他现代服务
6611769,//交通运输服务
6612276,//陆路运输服务
6612277,//水路运输服务
6612278,//航空运输服务
6612279,//管道运输服务
6612280,//无运输工具承运业务
6612289,//无船承运
6612292,//无运输工具承运陆路运输业务
6612294,//无运输工具承运铁路运输服务
6612296,//无运输工具承运铁路旅客运输服务
6612298,//无运输工具承运铁路货物运输服务
6612299,//无运输工具承运道路运输服务
6612300,//无运输工具承运道路旅客运输服务
6612301,//无运输工具承运道路货物运输服务
6612302,//无运输工具承运水路运输服务
6612304,//无运输工具承运水路旅客运输服务
6612305,//无运输工具承运水路货物运输服务
6612307,//无运输工具承运航空运输服务
6612309,//无运输工具承运航空旅客运输服务
6612310,//无运输工具承运航空货物运输服务
6612313,//无运输工具承运管道运输服务
6612315,//无运输工具承运联运运输服务
6612317,//无运输工具承运旅客联运运输服务
6612318,//无运输工具承运货物联运运输服务
6612320,//其他无运输工具承运业务
6612323,//其他无运输工具承运旅客运输业务
6612324,//其他无运输工具承运货物运输业务
6612281,//联运服务
6557930,//发票检查
6557931,//发票检查的意义及税务机关的检查范围
6557932,//发票检查的意义
6557934,//税务机关进行发票检查的范围
6557935,//被查单位和个人应履行的义务
6557936,//发票检查的内容及形式
6557937,//发票检查的内容
6557938,//发票检查形式
6557939,//境外取得发票的检查处理
6557940,//发票真伪的查询
6557941,//发票检查的方法
6557942,//调账检查
6557943,//实地检查
6557944,//发票专项检查工作
6557945,//发票检查的步骤
6557946,//检查准备阶段
6557947,//检查实施阶段
6557948,//检查终结阶段
6557949,//发票版式
6557950,//税控发票发票版式
6557998,//税务检查
6557999,//代开增值税专用发票
6558000,//机动车销售统一发票
6558001,//外出经管活动税收管理证明
6558002,//信息公开
6558003,//虚开发票
6594232,//发票开具规定
6594239,//发票开具规定
6594252,//发票开具规定
6594257,//发票开具规定
6594260,//发票开具规定
6594265,//发票开具规定
6594268,//发票开具规定
6594288,//发票开具规定
6594292,//发票开具规定
6594296,//发票开具规定
6594301,//发票开具规定
6594306,//发票开具规定
6594309,//发票开具规定
6594312,//税种及税率
6594960,//增值税
6594961,//企业所得税
6611155,//企业所得税税收优惠
6594315,//发票开具规定
6594317,//税种及税率
6594958,//增值税
6594959,//企业所得税
6611154,//企业所得税税收优惠
6594319,//发票开具规定
6594320,//税种及税率
6594954,//增值税
6594956,// 企业所得税
6611152,//企业所得税税收优惠
6594322,//发票开具规定
6594323,//税种及税率
6594949,//增值税
6594952,//企业所得税
6611151,//企业所得税税收优惠
6594325,//发票开具规定
6594328,//税种及税率
6594943,//增值税
6594946,//企业所得税
6611149,//企业所得税税收优惠
6594336,//发票开具规定
6594337,//税种及税率
6594939,//增值税
6594941,//企业所得税
6611147,//企业所得税税收优惠
6594343,//发票开具规定
6594344,//税种及税率
6594928,//增值税
6594930,//企业所得税
6611146,//企业所得税税收优惠
6594349,//税种及税率
6594925,//增值税
6594927,//企业所得税
6611144,//企业所得税税收优惠
6594353,//税种及税率
6594922,//增值税
6594924,// 企业所得税
6611143,//企业所得税税收优惠
6594358,//税种及税率
6594918,//增值税
6594920,//企业所得税
6611142,//企业所得税税收优惠
6594363,//税种及税率
6594913,//增值税
6594915,//企业所得税
6611141,//企业所得税税收优惠
6594366,//税种及税率
6594909,//增值税
6594911,//企业所得税
6611140,//企业所得税税收优惠
6594372,//发票开具规定
6594375,//发票开具规定
6594379,//发票开具规定
6594846,//发票开具规定
6594390,//发票开具规定
6594394,//发票开具规定
6594397,//发票开具规定
6594403,//发票开具规定
6594407,//发票开具规定
6594410,//发票开具规定
6594413,//发票开具规定
6594417,//发票开具规定
6594422,//发票开具规定
6594427,//发票开具规定
6594431,//发票开具规定
6594805,//发票开具规定
6594434,//发票开具规定
6594442,//发票开具规定
6594446,//发票开具规定
6594450,//发票开具规定
6594470,//发票开具规定
6594507,//发票开具规定
6594518,//发票开具规定
6594522,//发票开具规定
6594748,//企业所得税
6594637,//发票开具规定
6594641,//发票开具规定
6594644,//发票开具规定
6594648,//发票开具规定
6594651,//发票开具规定
6594655,//发票开具规定
6594658,//发票开具规定
6594662,//发票开具规定
6626810,//免征增值税
6626816,//免征增值税
6626822,//免征增值税
6626828,//税收优惠
6626832,//增值税
6626834,//免征增值税
6626840,//免征增值税
6626846,//免征增值税
6626852,//免征增值税
6626858,//免征增值税
6626861,//其他教育服务
6627202,//税种及税率
6627210,//增值税
6627211,//企业所得税
6627203,//税收优惠
6627205,//免征增值税
6627206,//加计抵减
6627208,//企业所得税税收优惠
6627204,//发票开具规定
6626957,//发票开具规定
6626960,//发票开具规定
6626963,//发票开具规定
6626966,//发票开具规定
6626969,//发票开具规定
6626972,//发票开具规定
6626975,//发票开具规定
6626978,//发票开具规定
6627027,//其他健康服务
6627028,//互联网医疗服务
6627326,//税种及税率
6627426,//增值税
6627434,//企业所得税
6627327,//税收优惠
6627446,//免征增值税
6627456,//加计抵减
6627465,//企业所得税税收优惠
6627335,//发票开具规定
6627029,//健康咨询服务
6627325,//税种及税率
6627427,//增值税
6627435,//企业所得税
6627328,//税收优惠
6627447,//免征增值税
6627457,//加计抵减
6627466,//企业所得税税收优惠
6627336,//发票开具规定
6627030,//健康体检服务
6627324,//税种及税率
6627428,//增值税
6627436,//企业所得税
6627329,//税收优惠
6627448,//免征增值税
6627458,//加计抵减
6627468,//企业所得税税收优惠
6627337,//发票开具规定
6627031,//心理健康服务
6627323,//税种及税率
6627429,//增值税
6627438,//企业所得税
6627330,//税收优惠
6627449,//免征增值税
6627459,//加计抵减
6627469,//企业所得税税收优惠
6627338,//发票开具规定
6627032,//精神康复服务
6627322,//税种及税率
6627430,//增值税
6627439,//企业所得税
6627331,//税收优惠
6627451,//免征增值税
6627461,//加计抵减
6627470,//企业所得税税收优惠
6627339,//发票开具规定
6627033,//中医保健服务
6627321,//税种及税率
6627431,//增值税
6627440,//企业所得税
6627332,//税收优惠
6627452,//免征增值税
6627462,//加计抵减
6627471,//企业所得税税收优惠
6627340,//发票开具规定
6627034,//健康保障服务
6627320,//税种及税率
6627432,//增值税
6627441,//企业所得税
6627333,//税收优惠
6627453,//免征增值税
6627463,//加计抵减
6627472,//企业所得税税收优惠
6627341,//发票开具规定
6627035,//其他未列明的健康服务
6627319,//税种及税率
6627433,//增值税
6627442,//企业所得税
6627334,//税收优惠
6627454,//免征增值税
6627464,//加计抵减
6627473,//企业所得税税收优惠
6627342,//发票开具规定
6627048,//发票开具规定
6627051,//发票开具规定
6627054,//发票开具规定
6627057,//发票开具规定
6627060,//发票开具规定
6627063,//发票开具规定
6561566,
6561567,
6561568,
6572809,
6573072,
6577160,
6572803,
6573095,
6573115,
6573124,
6577174,
6577179,
6577217,
6561569,
6573129,
6573141,
6577252,
6577306,
6561570,
6573166,
6577369,
6561571,
6573184,
6577403,
6578356,
6561572,
6561573,
6573210,
6578374,
6578387,
6578397,
6579534,
6579559,
6561574,
6573224,
6573245,
6579595,
6579628,
6579687,
6579741,
6579790,
6561575,
6561576,
6573257,
6574908,
6581083,
6561577,
6574915,
6574922,
6574927,
6561578,
6561579,
6574935,
6574938,
6614085,
6614107,
6614117,
6614119,
6614126,
6614144,
6614228,
6561580,
6574954,
6574965,
6614223,
6614230,
6615189,
6615194,
6615198,
6615232,
6561581,
6561582,
6574976,
6574983,
6561583,
6575023,
6575044,
6575052,
6561584,
6575415,
6575433,
6575443,
6561585,
6561586,
6575933,
6561588,
6575959,
6561589,
6561590,
6575970,
6561591,
6575988,
6575469,//	城乡市容管理
6577060,//	录音制作
6565322,//	补充保险
6565302,//	健身休闲活动
6565301,//	体育场地设施管理
6565270,//	体育场馆建筑
6565256,//	非金融机构支付服务
6565255,//	控股公司服务
6565243,//	证券期货监管服务
6565230,//	保险监管服务
6565229,//	保险资产管理
6565228,//	保险中介服务
6565227,//	商业养老金
6565222,//	银行监管服务
6565221,//	银行理财服务
6565092,//	搬家运输
6565079,//	其他城市公共交通运输
6565078,//	公共自行车服务
6565038,//	煤气生产和供应业
6565037,//	液化石油气生产和供应业
6564920,//	苇田
6564877,//	增量房（非住房买卖）
6564822,//	摩托车
6564806,//	鞭炮、焰火
6564796,//	其他转让所得
6564789,//	其他财产租赁所得
6564782,//	稿酬所得
6564773,//	构筑物-增量房
6564718,//	不动产融资租赁
6564674,//	其他采矿业
6564671,//	黑色金属矿产品
6564668,//	盐
6564667,//	洗煤
6564661,//	家具制造业
6564655,//	其他电气机械及器材制造业
6564654,//	电线电缆
6564652,//	家用电器
6632052,//	自行车
6632051,//	摩托车
6564631,//	水泥制品
6564630,//	水泥
6564627,//	汽车轮胎
6564624,//	护肤护发品
6564620,//	化学化工产品
6634431,// 综合性规定
6634432,// 生育保险  
6634433,// 养老保险  
6634434,// 医疗保险  
6634435,// 失业保险  
6634436,// 工伤保险  
]

export default{
    clearArr
}